import { Transition } from '@headlessui/react'
import React from 'react';


function Announcement() {
  const [isShowing, setIsShowing] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsShowing(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Transition
        appear={true}
        show={isShowing}
        enter="transition-opacity duration-500"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-x-0 bottom-0 p-4">
          <div
            className="relative flex items-center justify-between gap-4 rounded-lg bg-indigo-600 px-4 py-3 text-white shadow-lg"
          >
            <p className="text-center text-sm font-medium">
              Get in touch with us via phone <a href="tel:5195881970" className="inline-block underline">(519) 588-1970</a> or email <a href="mailto:office@maximumcontracting.ca" className="inline-block underline">office@maximumcontracting.ca</a>
            </p>

            <button
              aria-label="Close"
              className="shrink-0 rounded-lg bg-black/10 p-1 transition hover:bg-black/20"
              onClick={() => setIsShowing(false)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>

      </Transition>
    </>
  );
}

export default Announcement;